/**
 * Shared DeckBuilder configuration
 */

// Cards per row in the grid layout
export const CARDS_PER_ROW = 9;

// Number of rows to load per page
export const ROWS_TO_LOAD = 6;

// Total cards per page (calculated)
export const CARDS_PER_PAGE = CARDS_PER_ROW * ROWS_TO_LOAD;
